import HowToRegIcon from "@mui/icons-material/HowToReg";
import HotelIcon from "@mui/icons-material/Hotel";
import HistoryIcon from "@mui/icons-material/History";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export const item = [
  {
    id: 1,
    title: "HOME",
    listItem: [
      {
        id: 1,
        title: "Arriving Guests",
        url: "/adminuser/views",
        icon: <HowToRegIcon />,
      },
      {
        id: 2,
        title: "Current Guests",
        url: "/adminuser/views/currentguest",
        icon: <HotelIcon />,
      },
      {
        id: 3,
        title: "Past Guests",
        url: "/adminuser/views/pastguest",
        icon: <HistoryIcon />,
      },
      {
        id: 4,
        title: "View Recepits",
        url: "/adminuser/views/recipts",
        icon: <ReceiptLongIcon />,
      },
    ],
  },
];
